import { useEffect, useState } from 'react'

export const useDirectMessageCount = ({ initialValue, realtimeConnect, userId, populateUnreadDirectMessageFlag }) => {
  const [unreadDirectMessageCount, setUnreadDirectMessageCount] = useState(initialValue)
  useEffect(() => {
    if (userId && realtimeConnect) {
      populateUnreadDirectMessageFlag()
      realtimeConnect(`${userId}-MessageCentre`, (newMessage) => {
        if (newMessage.Message.SenderId !== userId) {
          populateUnreadDirectMessageFlag()
        }
      })
    }
  }, [userId, realtimeConnect, populateUnreadDirectMessageFlag])

  useEffect(() => {
    let unmounted = false
    if (initialValue !== unreadDirectMessageCount && !unmounted) {
      setUnreadDirectMessageCount(initialValue)
    }
    return () => {
      unmounted = true
    }
  }, [initialValue]) // eslint-disable-line

  return unreadDirectMessageCount
}
